export default "__VITE_ASSET__BTXc4N2i__"